export const ACCOMMODATION_TILE = {
    HIGH_PRIORITY_COUNT_DESKTOP: 3,
    HIGH_PRIORITY_COUNT_MOBILE: 2,
    IMAGE_COUNT: 1,
    LAYOUT_BREAKPOINT: 'md',
    MAX_MOBILE_BADGES: 2,
    MAX_AMENITIES_DESKTOP: 3,
    MAX_AMENITIES_MOBILE: 5,
};
